export const M365_CALLBACK_PATH = "/auth/m365/callback"
export const M365_CONNECTION_PATH = "/auth/m365/connection"
export const M365_RETURN_KEY = "m365-connection-return"
/** Query parameter on the connection page naming where "Return" goes. */
export const M365_RETURN_PARAM = "return"

/** Never follow a return URL outside this app, including protocol-relative URLs. */
export function safeM365ReturnPath(value: string | null, origin: string): string {
  if (!value) return "/agents"
  try {
    const target = new URL(value, origin)
    if (target.origin !== origin || target.pathname === M365_CALLBACK_PATH) return "/agents"
    return `${target.pathname}${target.search}${target.hash}`
  } catch {
    return "/agents"
  }
}

/**
 * Link to the connection page that remembers where the user came from, so its
 * "Return" goes back there (e.g. the agent thread) instead of the roster.
 */
export function m365ConnectionHref(returnTo: string): string {
  if (!returnTo) return M365_CONNECTION_PATH
  return `${M365_CONNECTION_PATH}?${new URLSearchParams({ [M365_RETURN_PARAM]: returnTo })}`
}

/**
 * Where the connection page's "Return" goes: the same-origin path named in its
 * `return` parameter, else the agent roster. Never the connection page itself
 * (a loop) and never off-origin (same rules as the consent callback).
 */
export function m365ConnectionReturnPath(search: string, origin: string): string {
  const target = safeM365ReturnPath(new URLSearchParams(search).get(M365_RETURN_PARAM), origin)
  return new URL(target, origin).pathname === M365_CONNECTION_PATH ? "/agents" : target
}

let pendingAuthorizationResponse: string | undefined
/** Isolate backend consent from the app's own MSAL redirect handler. Memory only. */
export function captureM365AuthorizationResponse(): void {
  if (typeof window === "undefined" || location.pathname !== M365_CALLBACK_PATH || !location.search)
    return
  const input = new URLSearchParams(location.search)
  const response = new URLSearchParams()
  for (const key of ["code", "state", "error", "error_description"]) {
    const value = input.get(key)
    if (value) response.set(key, value)
  }
  pendingAuthorizationResponse = response.toString()
  history.replaceState(history.state, "", location.pathname)
}
export function takeM365AuthorizationResponse(): string | undefined {
  const response = pendingAuthorizationResponse
  pendingAuthorizationResponse = undefined
  return response
}
